/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Teams_Settings_Phone_Is_Camera_Enabled_By_DefaultInputs */

const en_forms_teams_settings_phone_is_camera_enabled_by_default = /** @type {(inputs: Forms_Teams_Settings_Phone_Is_Camera_Enabled_By_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`By Default`)
};

const de_forms_teams_settings_phone_is_camera_enabled_by_default = /** @type {(inputs: Forms_Teams_Settings_Phone_Is_Camera_Enabled_By_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kamera standardmäßig aktiviert`)
};

/**
* | output |
* | --- |
* | "By Default" |
*
* @param {Forms_Teams_Settings_Phone_Is_Camera_Enabled_By_DefaultInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const forms_teams_settings_phone_is_camera_enabled_by_default = /** @type {((inputs?: Forms_Teams_Settings_Phone_Is_Camera_Enabled_By_DefaultInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Teams_Settings_Phone_Is_Camera_Enabled_By_DefaultInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forms_teams_settings_phone_is_camera_enabled_by_default(inputs)
	return de_forms_teams_settings_phone_is_camera_enabled_by_default(inputs)
});